import { Component } from '@angular/core';
import { SectionCardInterface } from '../../data/interfaces/SectionCardInterface';
import { PRIVATE_SECURITY_CARDS } from '../../data/private-security-cards.data';
import { SectionCard } from '../section-card/section-card';

@Component({
  selector: 'app-private-security',
  imports: [SectionCard],
  templateUrl: './private-security.html',
  styleUrl: './private-security.scss',
})
export class PrivateSecurity {

  cards: Array<SectionCardInterface> = PRIVATE_SECURITY_CARDS
}
